export default __webpack_public_path__ + "static/media/booking ui-whitebg.a42642ab.png";